module.exports = __webpack_public_path__ + "img/oneList2_new.84c4e968.png";